<app-viz-thumbnail-container [size]='size' [title]='title'>
    <!-- <div [style.width.%]='100' [style.height.%]='100' class="d-flex flex-column"> -->
    <img alt='Image' class="vizImage" [src]="_DomSanitizer.bypassSecurityTrustUrl(getImage(0))" />
    <!-- </div> -->

</app-viz-thumbnail-container>